<template>
  <div class="ws-request-exams-table-details">
    <ws-list-view class="is-table is-small"
                  :bordered="true"
                  :data="newItems"
                  :header="true"
                  :detailed="false"
                  :columns="columns">
      <template slot-scope="props">
        <ws-list-view-item-column>
          <span v-text="props.row.number"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span class="has-text-ellipsis display-block" v-text="props.row.university.title.translate.ru"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span v-text="props.row.education_group.name"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span v-text="props.row.shift.number"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <ws-time-formatter :date="props.row.job_issued_at" />
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <ws-time-formatter :date="props.row.started_at" />
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <ws-time-formatter :date="props.row.ended_at" />
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span v-text="props.row.student || '0'"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth has-text-right">
            <b-tooltip :label="$t('Редактировать')" type="is-dark">
              <button class="button is-text" :aria-label="$t('Редактировать')" @click="editItem(props.row)">
                <ws-icon
                  class="ws-button__icon"
                  name="edit"
                  color="#6D9AE8"
                  :fill="false"
                  width="14"
                  height="14"
                />
              </button>
            </b-tooltip>
            <b-tooltip :label="$t('Сделать копию')" type="is-dark">
              <button class="button is-text" :aria-label="$t('Сделать копию')" @click="cloneItem(props.row)">
                <ws-icon
                  class="ws-button__icon"
                  name="copy"
                  color="#6D9AE8"
                  :fill="false"
                  width="14"
                  height="14"
                />
              </button>
            </b-tooltip>
            <b-tooltip :label="$t('Удалить')" type="is-danger">
              <button class="button is-text" :aria-label="$t('Удалить')" @click="removeItem(props.row)">
                <ws-icon
                  class="ws-button__icon"
                  name="trash"
                  color="#6D9AE8"
                  :fill="false"
                  width="14"
                  height="14"
                />
              </button>
            </b-tooltip>
          </div>
        </ws-list-view-item-column>
      </template>
      <template slot="header" slot-scope="props">
        <strong>{{ props.column.label }}</strong>
      </template>
    </ws-list-view>
    <footer class="ws-request-exams-table-details__footer columns">
      <div class="column is-8 is-vcentered">
        <button class="ws-button button is-text"  @click="addGroupsToItem(exam.guid)">
          <ws-icon
            class="ws-button__icon is-position-left"
            name="plus-circle"
            :title="$t('Добавить группу')"
            color="#1c3b8d"
            width="20"
            height="20"
          />
          <strong class="ws-button__text has-text-primary" v-text="$t('Добавить группу')"></strong>
        </button>
      </div>
      <div class="column is-4 is-vcentered">
        <div class="has-text-right-desktop">
          <button class="ws-button button is-large is-primary is-outlined is-fullwidth"
                  :disabled="!isCanReview(exam)"
                  @click="updateExamStatus">
            <span class="is-size-4 has-text-weight-bold" v-text="$t('Согласовать')"></span>
          </button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import WsRequestExamsChooseGroup from '@/components/de/request-exams/modals/WsRequestExamsChooseGroup'
export default {
  name: 'WsRequestExamsTableDetails',
  props: {
    exam: Object,
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      newExam: {},
      newItems: [],
      columns: [
        {
          field: 'title',
          label: this.$t('№ Группы')
        },
        {
          field: 'submitted_at',
          label: this.$t('Образовательная организация')
        },
        {
          field: 'de_center',
          label: this.$t('Учебная группа')
        },
        {
          field: 'complexity_level',
          label: this.$t('№ Смены')
        },
        {
          field: 'prev_accreditation',
          label: this.$t('Выдача задания')
        },
        {
          field: 'status',
          label: this.$t('Дата начала')
        },
        {
          field: 'status',
          label: this.$t('Дата окончания')
        },
        {
          field: 'status',
          label: this.$t('Обучающихся')
        },
        {
          label: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters('exams', {
      examGroups: 'list'
    })
  },
  watch: {
    exam: {
      deep: true,
      immediate: true,
      handler (exam) {
        this.newExam = exam
      }
    },
    items: {
      immediate: true,
      // deep: true,
      handler (items) {
        this.newItems = items ? [...items.map(item => {
          const groups = item.groups || []
          if (groups.length) {
            groups.forEach(group => {
              if (group.shift) {
                group.shift.guid = item.guid
                group.shift.number = item.number
              }
            })
          }
          return groups
        })].reduce((acc, val) => acc.concat(val), []) : []
      }
    }
  },
  methods: {
    ...mapActions('exams', ['update']),
    ...mapMutations('exams', ['setCurrent']),
    addGroupsToItem () {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsChooseGroup,
        hasModalCard: true,
        props: {
          exam: this.exam
        },
        events: {
          'onAddNewItem': item => {
            this.newItems = item.shifts ? [...item.shifts.map(item => {
              const groups = item.groups || []
              if (groups.length) {
                groups.forEach(group => {
                  if (group.shift) {
                    group.shift.guid = item.guid
                    group.shift.number = item.number
                  }
                })
              }
              return groups
            })].reduce((acc, val) => acc.concat(val), []) : []
          }
        },
        canCancel: false
      })
    },
    editItem (item) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsChooseGroup,
        hasModalCard: true,
        props: {
          exam: this.exam,
          item: item
        },
        events: {
          'onAddNewItem': item => {
            this.newItems = item.shifts ? [...item.shifts.map(item => {
              const groups = item.groups || []
              if (groups.length) {
                groups.forEach(group => {
                  if (group.shift) {
                    group.shift.guid = item.guid
                    group.shift.number = item.number
                  }
                })
              }
              return groups
            })].reduce((acc, val) => acc.concat(val), []) : []
          }
        },
        canCancel: false
      })
    },
    updateItems (item) {
      this.newItems = item.shifts ? [...item.shifts.map(item => {
        const groups = item.groups || []
        if (groups.length) {
          groups.forEach(group => {
            if (group.shift) {
              group.shift.guid = item.guid
              group.shift.number = item.number
            }
          })
        }
        return groups
      })].reduce((acc, val) => acc.concat(val), []) : []
    },
    async cloneItem (item) {
      const updateItem = await this.update([
        this.exam.guid,
        {
          update: [{
            education_group: {
              guid: item.education_group.guid
            },
            student: item.student,
            shift: item.shift,
            job_issued_at: item.job_issued_at,
            started_at: item.started_at,
            ended_at: item.ended_at
          }]
        },
        '/groups'
      ])
      this.updateItems(updateItem)
    },
    removeItem (item) {
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить группу № «${item.number}»?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async () => {
          const updateItem = await this.update([this.exam.guid, { delete: [item.guid] }, '/groups'])
          this.updateItems(updateItem)
        }
      })
    },
    // TODO translate messages
    async updateExamStatus () {
      try {
        await this.update([this.exam.guid, [], `/status/under_review`])
        this.$buefy.toast.open({
          message: `Заявка ${this.exam.name.translate.ru} была успешно согласована`,
          type: 'is-success'
        })
      } catch (e) {
        this.$buefy.toast.open({
          message: `Что-то пошло не так. Попробуйте еще раз`,
          type: 'is-danger'
        })
      }
    },
    isCanReview (exam) {
      if (exam.status === 'review_de_department') {
        return false
      }
      if (exam.shifts && exam.shifts.length) {
        for (let shift of exam.shifts) {
          if (shift.groups && shift.groups.length) {
            return true
          }
        }
      }
      return false
    }
  },
  mounted () {
  }
}
</script>
